import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DateState {
  startDate: string;
  endDate: string;
}

const initialState: DateState = {
  startDate: new Date().toISOString().split("T")[0], // Default to today
  endDate: new Date().toISOString().split("T")[0],   // Default to today
};

const dateSlice = createSlice({
  name: "date",
  initialState,
  reducers: {
    setOptimizerGridcoStartDate: (state, action: PayloadAction<string>) => {
      state.startDate = action.payload;
    },
    setOptimizerGridcoEndDate: (state, action: PayloadAction<string>) => {
      state.endDate = action.payload;
    },
    setOptimizerGridcoDateRange: (
      state,
      action: PayloadAction<{ startDate: string; endDate: string }>
    ) => {
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
    },
  },
});

export const { setOptimizerGridcoStartDate, setOptimizerGridcoEndDate, setOptimizerGridcoDateRange } = dateSlice.actions;
export default dateSlice.reducer;
